import React from 'react';

import { HERO_EYEBROW, HERO_LEDE } from '../../constants';

import styles from './styles.module.css';

const Hero: React.FC = () => (
  <section className={styles.hero} id="top">
    <div className={styles.shell}>
      <div className={styles.eyebrow}>{HERO_EYEBROW}</div>
      <h1 className={styles.headline}>
        Let&apos;s talk <em>resale.</em>
      </h1>
      <p className={styles.lede}>{HERO_LEDE}</p>
    </div>
  </section>
);

export default Hero;
